import { useEffect, useState } from "react";
import axios from "axios";
import swal from "sweetalert";
import { Navigate, useNavigate } from "react-router-dom"; //Outlet,
import Loading from "./components/admin/childComponents/appComponents/Loading";

const AdminPrivateRoutes = () => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate("");
  const [authenticated, setAuthenticated] = useState(false);
  const [loading, setloading] = useState(true);

  useEffect(() => {
    try {
      axios.get(BASE_URL + "checkingIfauthenticated").then((res) => {
        if (res?.data?.status === 200) {
          setAuthenticated(true);
        } else if (res?.data?.status === 500) {
          swal("Oops!", res.data.message, "error");
        }
        setloading(false);
      });
    } catch (error) {
      console.log(error.toJSON());
    }
    setAuthenticated(false);
  }, []);

  axios.interceptors.response.use(undefined, (error) => {
    if (error.response.status === 401) {
      swal(
        "Unauthorized Attempt! Logout!",
        error.response.data.message,
        "warning",
      );
      navigate("/login");
    } else if (error.response.status === 403) {
      //Access Denied
      swal("Forbedden!", error.response.data.message, "warning");
      navigate("/admin/dashboard");
    } else if (error.response.status === 404) {
      //Page not found
      swal("404 Error!", error.response.data.message, "warning");
      navigate("/admin/dashboard");
    }

    return Promise.reject(error);
  });

  if (loading) {
    return <Loading message01={"Loading..."} />;
  }
  return !authenticated && <Navigate to="/login" />;
  //return authenticated ? <Outlet /> : <Navigate to="/login" />;
  /**/
};

export default AdminPrivateRoutes;
